import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
gsap.registerPlugin(ScrollTrigger, SplitText);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.SplitText = SplitText;

const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

(function headerAnimation() {
	const header = document.querySelector('#site-header');
	const overlay = document.querySelector('[data-overlay]');
	const breadcrumbs = document.querySelector('[data-breadcrumbs]');
	const footer = document.querySelector('footer');
	const visited = localStorage.getItem('visited');
	if (null === visited) {
		// header is set to 0 opacity in header.php to prevent animation delay issues
		localStorage.setItem('visited', true);
	}
	if (prefersReduced) {
		gsap.set(overlay, {
			opacity: 0,
			pointerEvents: 'none',
		});
		gsap.set(header, {
			opacity: 1,
		});
		return;
	}

	const timeline = gsap.timeline({ paused: true });
	if (overlay) {
		timeline.to(overlay, {
			opacity: 0,
			pointerEvents: 'none',
			duration: 1,
			ease: 'power4.in',
		});
	}
	if (header && null === visited) {
		timeline.to(
			header,
			{
				opacity: 1,
				duration: 1,
			},
			'-=0.75'
		);
	}

	if (breadcrumbs) {
		gsap.set(breadcrumbs, {
			opacity: 0,
		});
		timeline.to(
			breadcrumbs,
			{
				opacity: 1,
				duration: 1,
			},
			'-=0.75'
		);
	}

	if (footer) {
		gsap.set(footer, {
			opacity: 0,
		});
		timeline.to(
			footer,
			{
				opacity: 1,
				duration: 1,
			},
			'-=0.25'
		);
	}

	document.addEventListener('DOMContentLoaded', () => {
		timeline.play();
	});

	// beforeunload fires early enough for the leave fade to paint; pagehide is too late.
	window.addEventListener('beforeunload', () => {
		if (!overlay) {
			return;
		}
		gsap.killTweensOf(overlay);
		gsap.to(overlay, {
			opacity: 1,
			pointerEvents: 'auto',
			duration: 0.25,
			overwrite: true,
		});
	});

	// History back/forward restores from bfcache: DOMContentLoaded does not re-fire,
	// and any in-flight leave tween can resume and leave the overlay stuck.
	window.addEventListener('pageshow', (event) => {
		if (!overlay || !event.persisted) {
			return;
		}
		gsap.killTweensOf(overlay);
		gsap.set(overlay, {
			opacity: 1,
			pointerEvents: 'auto',
		});
		gsap.to(overlay, {
			opacity: 0,
			pointerEvents: 'none',
			duration: 1,
			ease: 'power4.in',
		});
	});
})();

(function items() {
	if (prefersReduced) {
		return;
	}
	let delay = 0;
	const breadcrumbs = document.querySelector('[data-breadcrumbs]');
	if (breadcrumbs) {
		delay += 250;
	}
	let items = document
		.querySelector('main')
		.querySelectorAll(
			'.text, blockquote:not([data-no-animate]), details:not([data-no-animate]), .grid-card:not([data-no-animate]), .article-card-featured:not([data-no-animate]), .business-card:not([data-no-animate]), .employee-card:not([data-no-animate]), .location-card:not([data-no-animate]), .vacancy-card:not([data-no-animate]), [data-animate]'
		);
	if (!items.length > 0) {
		return;
	}
	items = Array.from(items).filter((item) => typeof item.dataset.noAnimate !== 'string');

	if (window.scrollY < 50) {
		gsap.set(items, {
			opacity: 0,
		});
	}

	let refreshTimeout;
	const scheduleScrollTriggerRefresh = () => {
		clearTimeout(refreshTimeout);
		refreshTimeout = setTimeout(() => ScrollTrigger.refresh(), 150);
	};

	const initBatch = () => {
		ScrollTrigger.batch(items, {
			// Function keeps the offset viewport-relative on refresh (resize, late layout shifts).
			start: () => `top bottom-=${window.innerHeight / 6}`,
			onEnter: (batch) => {
				gsap.to(batch, {
					opacity: 1,
					stagger: 0.05,
					duration: 0.5,
				});
			},
		});
		scheduleScrollTriggerRefresh();
	};

	document.addEventListener('DOMContentLoaded', () => {
		setTimeout(initBatch, delay);
	});

	window.addEventListener('load', scheduleScrollTriggerRefresh);
	document.fonts.ready.then(scheduleScrollTriggerRefresh);

	const main = document.querySelector('main');
	if (main && 'ResizeObserver' in window) {
		new ResizeObserver(scheduleScrollTriggerRefresh).observe(main);
	}
})();
